import {ChangeDetectorRef, Directive, HostListener, Input} from "@angular/core";
import {FUIAbstractInput} from "../../framework/abstract-input";

@Directive()
export abstract class FUIAbstractNumericInput extends FUIAbstractInput {
    private _displayedValue: string;

    @Input() decimals: number;

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    get displayedValue(): string {
        return this._displayedValue;
    }

    set displayedValue(displayedValue: string) {
        if (this.isValid(displayedValue)) {
            this._displayedValue = displayedValue;
        } else {
            const selectionStart: number = this.input.nativeElement.selectionStart - 1;
            const selectionEnd: number = this.input.nativeElement.selectionEnd - 1;
            this.input.nativeElement.value = this._displayedValue || "";
            this.input.nativeElement.selectionStart = selectionStart;
            this.input.nativeElement.selectionEnd = selectionEnd;
        }
        super.value = !this._displayedValue ? undefined : this._displayedValue === "." ? "0" : Number(this._displayedValue);
    }

    private setValidDisplayValue(value: string): void {
        this._displayedValue = value === "." ? "0" : value == undefined || this.decimals === undefined ? value : Number(value).toFixed(this.decimals);
    }

    private isValid(value: string): boolean {
        if (!value || value === ".") {
            return true;
        }
        if (isNaN(+value)) {
            return false;
        }
        if (this.decimals === undefined) {
            return true;
        }
        const i: number = value.indexOf(".");
        return i < 0 || i >= value.length - 3;
    }

    override set value(value: any) {
        super.value = value;
        this.setValidDisplayValue(value);
    }

    override writeValue(value: any): void {
        super.writeValue(value);
        this.setValidDisplayValue(value);
        if (!this.destroyed) {
            this.changeDetectorRef.detectChanges();
        }
    }

    /**
     * Perform events after a click on the host
     * @param element
     */
    @HostListener("click")
    public override click(): void {
        this.focus();
    }

    public override onBlur(event?: any): void {
        super.onBlur();
        this.setValidDisplayValue(super.value);
    }
}
